import { useCallback, useState } from "react";
import { ItemConfirmDialog } from "../ItemConfirmDialog";

export const useItemConfirm = (title, message) => {
    const [promise, setPromise] = useState(null);
    const [item, setItem] = useState("");

    const confirm = useCallback((description) => new Promise((resolve, reject) => {
            setItem(description)
            setPromise({ resolve });
        }),[]
    );

    const handleClose = () => {
        setPromise(null);
    };
    const handleConfirm = () => {
        promise?.resolve(true);
        handleClose();
    };
    const handleCancel = () => {
        promise?.resolve(false);
        handleClose();
    };

    const DialogConfirm = (): JSX.Element => {
        return (
            <ItemConfirmDialog
                onConfirm={handleConfirm}
                onClose={handleCancel}
                open={promise !== null}
                title={title}
                message={message}
                item={item}
            />
        );
    };
    
    return { DialogConfirm, confirm };
};
